import ApiService from './api.service'
import ToastService from '../_helpers/toast.service'
import { APP_LOCALE } from '../_helpers/config'

export default class BaseService {
  static list(searchParams) {
    return ApiService.query(this.resource, {
      searchParams
    })
  }

  static get(apiFuncName) {
    return ApiService.get(`${this.resource}/${apiFuncName}`)
  }

  static find(id) {
    return ApiService.get(`${this.resource}/find`, id)
  }

  static create(entity) {
    return this.post('create', entity)
  }

  static update(entity) {
    return this.post('update', entity)
  }

  static delete(id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.resource}/delete`, id)
        .then(response => {
          const message = APP_LOCALE === 'tr' ? 'Başarıyla silindi.' : 'Successfully deleted.'
          ToastService.success(message)
          resolve(response.data)
        })
        .catch(error => {
          ToastService.error(`Error : ${error.message}`)
          reject(error)
        })
    })
  }

  static post(apiFuncName, entity) {
    return this.postForResponse(apiFuncName, entity).then(response => response.data)
  }

  static postForResponse(apiFuncName, entity) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.resource}/${apiFuncName}`, entity)
        .then(response => {
          const message = APP_LOCALE === 'tr' ? 'Başarıyla kaydedildi.' : 'Successfully saved.'
          ToastService.success(message)
          resolve(response)
        })
        .catch(error => {
          ToastService.error(`Error : ${error.message}`)
          reject(error)
        })
    })
  }
}
